document.addEventListener('DOMContentLoaded', function () {
    const stickyContainer = document.querySelector('.sticky-container');
	const applyFiltersBtn = document.querySelector('.apply-filters-btn');
    // Only proceed if stickyContainer exists
    if (!stickyContainer) return;

    const pullToggleOn = document.querySelector('.pull-toggle-on');
    const pullToggleClose = document.querySelector('.pull-toggle-close');
    const body = document.body;

    // Open sidebar and add class to body
    if (pullToggleOn) {
        pullToggleOn.addEventListener('click', function (e) {
            e.stopPropagation();
            stickyContainer.classList.toggle('toggle-show');

            if (stickyContainer.classList.contains('toggle-show')) {
                body.classList.add('is-filter-open');
            } else {
                body.classList.remove('is-filter-open');
            }
        });
    }

    // Prevent click inside sidebar from closing it
    // Exception: apply-filters-btn and clear-all-filters need their click handlers to fire
    stickyContainer.addEventListener('click', function (e) {
        // These buttons need their jQuery handlers to fire, so let them propagate
        if (e.target.closest('.apply-filters-btn') || e.target.closest('.clear-all-filters')) {
            return;
        }
        // All other clicks inside sidebar should NOT close it
        e.stopPropagation();
    });

    // Click outside to close sidebar and remove body class
    // But NOT for clear-all-filters clicks (sidebar should stay open)
    document.addEventListener('click', function (e) {
        // Don't close sidebar when clear-all-filters is clicked
        if (e.target.closest('.clear-all-filters')) {
            return;
        }
        stickyContainer.classList.remove('toggle-show');
        body.classList.remove('is-filter-open');
    });

    // Close button inside sidebar
    if (pullToggleClose) {
        pullToggleClose.addEventListener('click', function () {
            stickyContainer.classList.remove('toggle-show');
            body.classList.remove('is-filter-open');
        });
    }

	// if apply-filters-btn is clicked, close sidebar
	if (applyFiltersBtn) {
		applyFiltersBtn.addEventListener('click', function () {
			stickyContainer.classList.remove('toggle-show');
			body.classList.remove('is-filter-open');
		});
	}
});
